import React, { Component } from 'react'
import { Button, CardActions } from 'react-md'
import { reduxForm } from 'redux-form'

import { ArtworkStatus, UploadStatus } from 'api/enums'

class ViewHeader extends Component {
  componentWillReceiveProps (nextProps) {
    if (nextProps.uploadStatus !== this.props.uploadStatus &&
        nextProps.uploadStatus === UploadStatus.FAILED &&
        nextProps.isEditing) {
      nextProps.onToggleDetails(true)
    }
  }

  render () {
    const {
      artworkStatus,
      disableDelete,
      enablePublish,
      enableUnpublish,
      handleSubmit,
      onGoBack,
      onDelete,
      onRequestPublishing,
      onCancelPublishRequest,
      onPublish,
      onUnpublish,
      onToggleDetails,
      uploadStatus,
      isUploading,
      isEditing,
      pristine,
      reset
    } = this.props

    return (
      <div className='view-header'>

        <CardActions className='view-actions view-actions--left'>
          { !isUploading && (
            <Button flat iconChildren='navigate_before' onClick={onGoBack}>
              Back
            </Button>
          ) }
        </CardActions>

        <CardActions className='view-actions view-actions--right'>
          { isUploading && !isEditing && uploadStatus !== UploadStatus.FAILED && (
            <Button flat iconChildren='edit' onClick={onToggleDetails}>
              Edit
            </Button>
          ) }

          { isUploading && isEditing && uploadStatus !== UploadStatus.FAILED && (
            <Button flat iconChildren='not_interested'
              onClick={onToggleDetails}>
              Close Edit
            </Button>
          ) }

          { !disableDelete && (
            <Button flat iconChildren='delete' onClick={onDelete}>
              Delete
            </Button>
          ) }

          { artworkStatus === ArtworkStatus.DRAFT && pristine && (
            <Button
              flat
              primary
              iconChildren='cloud_upload'
              disabled={isUploading && uploadStatus !== UploadStatus.DONE}
              onClick={onRequestPublishing}
            >
              Request Publishing
            </Button>
          ) }

          { artworkStatus === ArtworkStatus.DRAFT && !pristine && (
            <div>
              <Button flat iconChildren='keyboard_backspace' onClick={reset}>
                Undo
              </Button>
              <Button flat primary iconChildren='cloud' onClick={handleSubmit}>
                Save
              </Button>
            </div>
          ) }

          { artworkStatus === ArtworkStatus.PENDING && enablePublish && (
            <Button flat iconChildren='cloud_done' onClick={onPublish}>
              Publish
            </Button>
          )}

          { artworkStatus === ArtworkStatus.PENDING && !enablePublish && (
            <Button flat iconChildren='cancel' onClick={onCancelPublishRequest}>
              Cancel Publish Request
            </Button>
          )}

          { artworkStatus === ArtworkStatus.PUBLISHED && enableUnpublish && (
            <Button flat iconChildren='cloud_download' onClick={onUnpublish}>
              Unpublish
            </Button>
          )}
        </CardActions>

      </div>
    )
  }
}

export default reduxForm({
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  pure: false
})(ViewHeader)



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/ViewHeader/index.js